/* eslint eqeqeq: 'off' */
import * as types from '../action/actionTypes';
import * as url from '../api/url';
import APIutil from '../api/APIutils';
import {global_error_handling} from './GlobalErrorMgmtAction';

// Displaying List of Tenants
export function makeGetCall() { 
     return function (dispatch) {
         return APIutil.getDataAPI(url.Get_Tenant_List).then(response => {
            dispatch(global_error_handling(response));  
            if(response != null && response != undefined)
                dispatch(actionToStoreSuccess(response,types.LOAD_TENANTS_LIST_SUCCESSFULL));
         }).catch(error => {
             throw error;
         })
     }
 }

 export function GetAllTenantList() { 
    return function (dispatch) {
        return APIutil.getDataAPI(url.Get_Tenant_Names).then(response => {
           dispatch(global_error_handling(response));  
           if(response != null && response != undefined)
               dispatch(actionToStoreSuccess(response,types.TENANTNAMES_LIST_SUCCESSFULL));
        }).catch(error => {
            throw error;
        })
    }
}

/* Delete Method for deleting single or multiple  Tenants*/

export function DeleteTenants(tenants_to_be_deleted) { 
    return function (dispatch) {
       return APIutil.deleteDataAPI(url.Get_Tenant_List,tenants_to_be_deleted).then(response => {
        dispatch(global_error_handling(response));    
        if(response.status == 200)
               dispatch(makeGetCall());
        }).catch(error => {
            throw error;
        })
    }
}



 export function GetCalculateCost(data){
    return function (dispatch) {
        return APIutil.postData(url.get_Cost,data).then(response => {
            dispatch(global_error_handling(response));  
            dispatch(actionToStoreSuccess(response,types.GET_COST_SUCCESSFULL));
        }).catch(error => {
            throw error;
        })
    }     
 }

export function SaveTenant(data) { 
    return function (dispatch) {
        return APIutil.postData(url.post_Tenant,data).then(response => {
            dispatch(global_error_handling(response));  
            if(response.status == 200)
                dispatch(actionToStoreSuccess(response,types.POST_SUCCESSFULL));
        }).catch(error => { throw error; })
    }
}

export function Getlicense(){
    return function (dispatch) {
        return APIutil.getDataAPI(url.licence_info).then(response => {
            dispatch(global_error_handling(response));
            //if(response.status == 200){  
                dispatch(actionToStoreSuccess(response,types.GET_LICENSE));
        }).catch(error => { throw error; })
    }
}

// View Individual Tenant 
export function IndividualTenantDetailGetCall(id) { 
    return function (dispatch) {
        return APIutil.GetDetailsByID(url.get_Tenant_By_ID,id).then(response => {
            dispatch(global_error_handling(response));  
            var TDL ={
                "CompleteInfo" :response,
                "CompanyInformation" :{"tenantId":response.tenantId,"tenantName":response.tenantName,"address":response.address,"invoiceEmail":response.invoiceEmail,"contactPhone":response.contactPhone,"currencyId":response.currencyId},
                "AfterHours" :{"tenantId":response.tenantId,"ratePerHour":response.ratePerHour,"minmumAfterHour":response.minmumAfterHour,"rounderHours":response.rounderHours,"zones":response.zones,"hasZoneRate":response.hasZoneRate,"facilitysetup":response.facilitySetup,"currencyId":response.currencyId},
                "HoursOfOperation": {"tenantId":response.tenantId,"HoursOfOperation" : response.normalHours},
                "UsageMeters": response.tenantConsumption,
                "FixedCharges": {"tenantId":response.tenantId,"FixedCharges":response.tenantFixedCharges}
              } 
            dispatch(actionToStoreSuccess(TDL,types.LOAD_VIEW_TENANT_SUCCESSFULL));
         
        }).catch(error => {
            throw error;
        })
    }
}


//get Zones by Tenant ID
export function GetZonesListforTenant(id) { 
    return function (dispatch) {
        return APIutil.getDataAPI(url.get_Zone_By_ID+id+"/zones").then(response => {
            dispatch(global_error_handling(response));  
           if(response != null && response != undefined){
            dispatch(actionToStoreSuccess(response,types.GET_ZONES_BY_TENANT_ID));
            return response;
           }
             else if(response.length == 0){
                dispatch(actionToStoreSuccess([],types.GET_ZONES_BY_TENANT_ID));
             }
        }).catch(error => {
            throw error;
        })
    }
}


//PUT Company Information

export function PutTenantDetailsAction(data,TenantID) { 
    return function (dispatch) {
        return APIutil.editDataAPI(url.edit_Tenant_Company_Info+TenantID+"/company",data).then(response => {
            dispatch(global_error_handling(response));  
            var TDL ={
                "CompanyInformation" :{"tenantId":TenantID,"tenantName":data.TenantName,"address":data.Address,"invoiceEmail":data.InvoiceEmail,"contactPhone":data.ContactPhone,"currencyId":data.CurrencyId},
              } 
            dispatch(actionToStoreSuccess(TDL,types.PUT_TENANT_COMPANY_INFO_SUCCESSFULL));
        }).catch(error => {
            throw error;
        })
    }
}



//PUT  Normal hours for tenant
export function PutNormalHoursAction (normalhours,TenantID) {
    return function (dispatch) {
        return APIutil.editDataAPI(url.edit_Tenant+TenantID+"/normalhours",normalhours,).then(response => {
            dispatch(global_error_handling(response));  
            if(response.status == 200)
            dispatch(IndividualTenantDetailGetCall(TenantID));
        }).catch(error => {
            throw error;
        })
    }
}



//PUT  After / Billing hours for tenant
export function PutAfterHoursAction (data,TenantID) {

    return function (dispatch) {
        return APIutil.editDataAPI(url.edit_Tenant+TenantID+"/billing",data).then(response => {
            dispatch(global_error_handling(response));  
            if(response.status == 200)
            var FacilitySetup ={"sendToAdditionalRecipient":data.FacilitySetup.SendToAdditionalRecipient,"sendToRequestedEmployee":data.FacilitySetup.SendToRequestedEmployee,"toEmailAddress":data.FacilitySetup.ToEmailAddress }
            var ZonesRates = [];
            if(data.Zones != undefined && data.Zones != null && data.Zones.length){
                data.Zones.map(el => (
                    ZonesRates.push({"zoneId" : el.zoneId,"rate" : el.Rate})
                ));
            }
            var TDL ={
                "AfterHours" :{"tenantId":TenantID,"ratePerHour":data.RatePerHour,"minmumAfterHour":data.MinmumAfterHour,"rounderHours":data.RounderHours,"facilitysetup":FacilitySetup,"zones":ZonesRates,"hasZoneRate":data.HasZoneRate},
              } 
            dispatch(actionToStoreSuccess(TDL,types.PUT_TENANT_AFTER_HOURS_SUCCESSFULL));
        }).catch(error => {
            throw error;
        })
    }
}

//PUT  Zones for tenant
export function PutZonesAction (data,TenantID) {

    return function (dispatch) {
        return APIutil.editDataAPI(url.edit_Tenant+TenantID+"/zones",data).then(response => {
            dispatch(global_error_handling(response));  
            if(response.status == 200)
            dispatch(GetZonesListforTenant(TenantID));
        }).catch(error => {
            throw error;
        })
    }
}

//Delete Method for deleting single or multiple zones

export function UnAssociateZone(zones_to_be_deleted, TenantID, IsReqDelete) { 
    return function (dispatch) {
       return APIutil.deleteDataAPI(url.edit_Tenant+TenantID+"/zones?removeFutureReqs="+IsReqDelete,zones_to_be_deleted).then(response => {
        dispatch(global_error_handling(response));     
        if(response.status == 200)
           dispatch(GetZonesListforTenant(TenantID));
        }).catch(error => {
            throw error;
        })
    }
}

// Post Tenant Employee Details
export function PostTenantEmployeesDetailsAction (data) {
    return function (dispatch) {
        return APIutil.postData(url.post_Tenant_Employees,data).then(response => {
            dispatch(global_error_handling(response));  
            dispatch(IndividualTenantDetailGetCall(data.TenantId));
        }).catch(error => {
            throw error;
        })
    }
}

//PUT Tenant Employee Details
export function PutTenantEmployeesDetailsAction (data) {
    return function (dispatch) {
        return APIutil.editDataAPI(url.put_Tenant_Employees+data.TenantUserId,data).then(response => {
            dispatch(global_error_handling(response));  
            if(response.status == 200)
            dispatch(IndividualTenantDetailGetCall(data.TenantId));
        }).catch(error => {
            throw error;
        })
    }
}

//Check Is LogOnName Exists
export function CheckIsLogOnNameExists(name) { 
    return function (dispatch) {
        var Data = {
            "LogOnName" : name
        }
        return APIutil.postData(url.get_Tenant_Employees_By_ID+"LogOnName",Data).then(response => {
            dispatch(actionToStoreSuccess(response.data,types.GET_IS_LOGONNAME_EXISTS));
        }).catch(error => { throw error; })
    }
}

// Post Fixed Charges of Individual Tenant
export function PostFixedCharges (data,TenantID) {
    return function (dispatch) {
        return APIutil.postData(url.edit_Tenant+TenantID+"/fixedCharges",data).then(response => {
            dispatch(global_error_handling(response));  
            dispatch(IndividualTenantDetailGetCall(TenantID));
           // dispatch(actionToStoreSuccess(response,types.POST_TENANT_EMPLOYEE_DETAILS_SUCCESSFULL));
        }).catch(error => {
            throw error;
        })
    }
}

// Put Fixed Charges of Individual Tenant
export function PutFixedCharges (data,TenantID) {
    return function (dispatch) {
        return APIutil.editDataAPI(url.edit_Tenant+TenantID+"/fixedCharges/"+data.fixedChargeId,data).then(response => {
            dispatch(global_error_handling(response));  
            dispatch(IndividualTenantDetailGetCall(TenantID));
        }).catch(error => { throw error; })
    }
}


 //Delete Method for deleting single or multiple fixed Charges

 export function DeleteCharges(tenantID,data) { 
    return function (dispatch) {
       return APIutil.deleteDataAPI(url.edit_Tenant+tenantID+"/fixedCharges",data).then(response => {
            dispatch(global_error_handling(response));  
            dispatch(IndividualTenantDetailGetCall(tenantID));
        }).catch(error => {
            throw error;
        })
    }
}

//Delete Method for deleting single or multiple Employees
export function DeleteEmployees(emps_to_be_deleted, TenantID, IsReqDelete) { 
    return function (dispatch) {
       return APIutil.deleteDataAPI(url.delete_Tenant_Employees+"?removeDependents="+IsReqDelete,emps_to_be_deleted).then(response => {
        dispatch(global_error_handling(response));     
        if(response.status == 200)
           dispatch(IndividualTenantDetailGetCall(TenantID));
        }).catch(error => {
            throw error;
        })
    }
}


/* Action to Store method returns the action type with the API response. The response object{type,response}
 will be returned to the Reducer checking it type and updates the state. */

export function actionToStoreSuccess(response,actionType){
    return{
        type: actionType,
        getResponse: response,
    }
}


/*Setting Global Tenant ID */
export function setUserID (userID) {
    return {
        type: types.SET_USER_ID,
        userID: userID,
    }

}

/*Setting Global Tenant IDs */
export function setUserIDs (userIDs) {
    return {
        type: types.SET_USER_IDS,
        userIDs: userIDs,
    }

}
